import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";

/**
 * Credit report upload dialog shared across court bond retrieval pages.
 */
export function BondRetrievalCreditReportDialog({
  open,
  onClose,
  bond_id,
  creditReportFile,
  setCreditReportFile,
  isCreditUploading,
  setIsCreditUploading,
  runCreditReport,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Upload Credit Report</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Upload the credit report PDF to notify the underwriter.
        </Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            padding: "6px 12px",
            borderRadius: "4px",
            backgroundColor: "#fafafa",
            display: "inline-block",
            fontSize: "0.9rem",
            cursor: isCreditUploading ? "not-allowed" : "pointer",
          }}
        >
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setCreditReportFile(e.target.files[0])}
            disabled={isCreditUploading}
            style={{ fontSize: "0.85rem", width: "100%" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isCreditUploading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            if (!creditReportFile) {
              toast.error("Please upload a PDF file.");
              return;
            }
            setIsCreditUploading(true);
            try {
              await runCreditReport(bond_id, creditReportFile);
              toast.success("Credit report uploaded successfully.");
              onClose();
              setCreditReportFile(null);
            } catch (error) {
              console.error(error);
              toast.error("Upload failed. Try again.");
            } finally {
              setIsCreditUploading(false);
            }
          }}
          disabled={isCreditUploading}
          endIcon={isCreditUploading && <CircularProgress size={20} />}
        >
          {isCreditUploading ? "Uploading..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BondRetrievalCreditReportDialog;
